(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/reject', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/reject'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.reject, global.convert);
    global.reject = mod.exports;
  }
})(this, function (exports, _reject2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.reject = undefined;

  var _reject3 = _interopRequireDefault(_reject2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an array of elements <code>predicate</code> returns falsy for.
   * @function
   * @memberof collection
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {function} [predicate={@link https://lodash.com/docs#identity|lodash.identity}] The function invoked per iteration.
   * @return {Object} Returns the updated object.
   * @see {@link https://lodash.com/docs#reject|lodash.reject} for more information.
   * @example reject({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', v => v % 2) // => { nested: { prop: [2, 4] } }
   * @since 0.3.0
   */
  var reject = (0, _convert.convert)(_reject3.default);
  exports.reject = reject;
  exports.default = reject;
});